import { assetUrl } from "./assetUrl"
import { CardElement } from "../types/battle"
import { ElementAbilitySlot } from "./elementAbilities"

/** Files in `assets/guardians/talents/` — `{element}_{slot}.png` (lightning → light). */
const TALENT_ICONS: Record<
  CardElement,
  Record<ElementAbilitySlot, string>
> = {
  EARTH: {
    1: assetUrl("talents/earth_1.png"),
    2: assetUrl("talents/earth_2.png"),
    3: assetUrl("talents/earth_3.png"),
  },
  FIRE: {
    1: assetUrl("talents/fire_1.png"),
    2: assetUrl("talents/fire_2.png"),
    3: assetUrl("talents/fire_3.png"),
  },
  WATER: {
    1: assetUrl("talents/water_1.png"),
    2: assetUrl("talents/water_2.png"),
    3: assetUrl("talents/water_3.png"),
  },
  WIND: {
    1: assetUrl("talents/wind_1.png"),
    2: assetUrl("talents/wind_2.png"),
    3: assetUrl("talents/wind_3.png"),
  },
  ICE: {
    1: assetUrl("talents/ice_1.png"),
    2: assetUrl("talents/ice_2.png"),
    3: assetUrl("talents/ice_3.png"),
  },
  LIGHTNING: {
    1: assetUrl("talents/light_1.png"),
    2: assetUrl("talents/light_2.png"),
    3: assetUrl("talents/light_3.png"),
  },
}

export function resolveTalentAbilityIcon(
  element: CardElement | null | undefined,
  slot: ElementAbilitySlot | number | null | undefined
): string | null {
  if (!element || slot == null) return null
  if (slot !== 1 && slot !== 2 && slot !== 3) return null
  return TALENT_ICONS[element]?.[slot] ?? null
}

export function resolveTalentAbilityIconById(
  abilityId: string | null | undefined
): string | null {
  if (!abilityId) return null
  // EARTH_1_THICKET → EARTH + 1
  const match = /^([A-Z]+)_([123])_/.exec(abilityId)
  if (!match) return null
  const element = match[1] as CardElement
  const slot = Number(match[2]) as ElementAbilitySlot
  return resolveTalentAbilityIcon(element, slot)
}
